import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { versionCheckQueries } from "@/api/version-check";
import { APP_VERSION } from "virtual:app-version";
import { useToast } from "@/hooks/use-toast";
import { ToastAction } from "@/components/ui/toast";

export function CheckForUpdatesToast() {
  const { toast } = useToast();
  const { data: mostRecentVersion } = useQuery(
    versionCheckQueries.getVersion(),
  );

  useEffect(() => {
    if (!mostRecentVersion) return;

    const shouldUpdate = APP_VERSION.localeCompare(mostRecentVersion) < 0;

    if (shouldUpdate) {
      toast({
        description: "A new version of the App is available. Please refresh.",
        action: (
          <ToastAction
            altText="Refresh"
            onClick={() => window.location.reload()}
          >
            Refresh
          </ToastAction>
        ),
        duration: 30000,
      });
    }
  }, [mostRecentVersion]);

  return null;
}
